import React, { useState, useEffect } from 'react';
import sNba from "../../../../services/nbaService";
import { Modal, Box, Button, Typography, List, ListItem, CircularProgress, Avatar } from '@mui/material';

interface ModalComponentProps {
  open: boolean;
  onClose: () => void;
  onSelect: (item:ItemNba) => void;
}

export interface ItemNba {
  idNbaEquipe: number;
  nomeEquipe: string;
}

const ModalComponent: React.FC<ModalComponentProps> = ({ open, onClose, onSelect }) => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<ItemNba | null>(null);


  const handleSelectItem = (item: ItemNba) => {
    setSelectedItem(item);
  };

  const handleConfirm = () => {
    if (selectedItem) {
      sNba.atualizaEquipeEscolhida(selectedItem.idNbaEquipe)
        .then(result => {
          console.log("Item atualizado com sucesso:", result);
          onSelect(selectedItem)
          onClose();
        })
        .catch(error => console.error("Erro ao atualizar item:", error));
    }
  };
  useEffect(() => {
    if (open) {
      setLoading(true);
      sNba.listaEquipes()  // Substitua pelo seu endpoint da API
        .then(resp => {

          if (resp.status === 200) {
            setData(resp.data);

          }
          setLoading(false);
        })
        .catch(() => {
          setData([]);
          setLoading(false);
        });
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: '16px',
          overflow: 'hidden'
        }}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <List style={{overflowY: 'scroll', maxHeight:550,}}>
            {data.length > 0 ? (
              data.map((item : ItemNba) => (
                <ListItem selected={selectedItem?.idNbaEquipe === item.idNbaEquipe}
                onClick={() => handleSelectItem(item)} key={item.idNbaEquipe} style={{display: 'flex', gap: '16px'}}>
                  <Avatar src={`./content/images/NbaTeamChoice-opcionais/NbaTeamChoice_${item.idNbaEquipe}.jpg`} sx={{ width: 56, height: 56 }}></Avatar>
                  {item.nomeEquipe}
                </ListItem>
              ))
            ) : (
              <Typography>Nenhum dado disponível</Typography>
            )}
          </List>
        )}
        <div style={{display: 'flex', justifyContent: "space-between", marginTop: '24px'}}>
          <Button onClick={onClose}>Fechar</Button>
          {selectedItem && (
            <Button variant="contained" color="primary" onClick={handleConfirm}>
              Confirmar
            </Button>
          )}
        </div>
        
      </Box>
    </Modal>
  );
};

export default ModalComponent;
